import type { AxiosResponse } from 'axios'

import mapConfigData from '@/store/sagas/apiDataMapping/configMapping'
import { FAPI_CONFIGURATION_ENDPOINT } from '@/libs/constants/b2bApiEndpoints'
import environment from '@/environments/environment.dev'

import HttpClient from '../apiHttpClient'

type MappedConfigData = Record<string, unknown>

/**
 * Service for handling configuration-related API operations
 */
class ConfigurationService {
  private readonly httpClient: HttpClient

  /**
   * Creates a new ConfigurationService instance
   * @param baseUrl - The base URL for configuration API endpoints
   */
  constructor(baseUrl: string) {
    this.httpClient = new HttpClient(baseUrl)
  }

  /**
   * Fetches configurations by their names
   * @param configArray - Array of configuration names to fetch
   * @returns Mapped configuration data
   */
  public async getConfigsByNames(
    configArray: Record<'configurationKey' | 'dataTypeDto', string>[],
  ): Promise<MappedConfigData> {
    const { data } = await this.httpClient.post('/list', {
      body: configArray,
    })
    return mapConfigData(data)
  }

  /**
   * Fetches the list of available countries
   * @returns Promise with country list data
   */
  public async getCountryList(): Promise<AxiosResponse> {
    return this.httpClient.get('/country')
  }
}

export const fapiConfigurationService = new ConfigurationService(
  `${environment.shopFAPIUrl}${FAPI_CONFIGURATION_ENDPOINT}`,
)

export default ConfigurationService
